import React, { useEffect, useRef, useState } from "react";
import styles from "./ContactForm.module.css";
import { db } from "../../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

// --- SENDZEN CONFIGURATION ---
const SENDZEN_CONFIG = {
  API_KEY: "sz_sandbox_Muc_zaaXPDpzVFtWeragtVuUDHYZi1_fPsWBhggy7Kj3aA", // Replace with your actual key
  OWNER_PHONE: "918554872614",      // Owner's number with country code
  TEMPLATE_NAME: "new_website_lead" // The name of the template you created
};

const services = [
  "VIP SERVICES", "BACHELORETTE", "LOUNGE BAR", "CORPORATE EVENTS",
  "BIRTHDAY PARTIES", "PRIVATE SHOOTS", "LOUNGE AREA", "BRANDED EVENTS"
];

const ContactForm = () => {
  const sectionRef = useRef(null);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    service: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const elements = sectionRef.current.querySelectorAll("[data-animate]");
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.show);
          }
        });
      },
      { threshold: 0.2 }
    );
    elements.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  // --- SENDZEN API HELPER ---
  // --- SENDZEN API HELPER ---
  const sendWhatsAppNotification = async (data) => {
    const url = "https://api.sendzen.io/v1/messages";

    const payload = {
      from: "15557814168", // Your Sandbox Number
      to: "919156249716",   // Recipient Number
      type: "text",
      text: {
        body: `*New Service Request!* 🚀\n\n` +
          `*Name:* ${data.fullName}\n` +
          `*Phone:* ${data.phone}\n` +
          `*Service:* ${data.service}\n` +
          `*Message:* ${data.message}`
      }
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${SENDZEN_CONFIG.API_KEY}`
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        console.log("WhatsApp Text Sent!");
      } else {
        const errorData = await response.json();
        console.error("API Error:", errorData);
      }
    } catch (err) {
      console.error("Connection still timing out:", err);
      // If you see this, your network is definitely blocking 'api.sendzen.io'
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { fullName, email, phone, service, message } = formData;

    if (!fullName || !email || !phone || !service || !message) {
      alert("Please fill all fields");
      return;
    }

    try {
      setLoading(true);

      // 1. Save to Firestore
      await addDoc(collection(db, "contactSubmissions"), {
        ...formData,
        createdAt: serverTimestamp(),
        status: "new"
      });

      // 2. Send WhatsApp through SendZen
      await sendWhatsAppNotification(formData);

      // Reset form
      setFormData({
        fullName: "",
        email: "",
        phone: "",
        service: "",
        message: ""
      });

      setSuccess(true);
      setTimeout(() => setSuccess(false), 4000);

    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section ref={sectionRef} className={styles.section}>
      <div className={styles.container}>
        <h1 data-animate className={`${styles.bgText} ${styles.animate} ${styles.fadeDown}`}>
          CONTACT US
        </h1>

        <h2 data-animate className={`${styles.title} ${styles.animate} ${styles.fadeUp}`}>
          CONTACT US
        </h2>

        <form onSubmit={handleSubmit} data-animate className={`${styles.form} ${styles.animate} ${styles.fadeUp} ${styles.delay1}`}>
          <div className={styles.row}>
            <div className={`${styles.field} ${styles.animate} ${styles.fadeLeft}`} data-animate>
              <label>FULL NAME</label>
              <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} placeholder="Ex. John Taitor" />
            </div>

            <div className={`${styles.field} ${styles.animate} ${styles.fadeRight}`} data-animate>
              <label>EMAIL ADDRESS</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="example@mail.com" />
            </div>
          </div>

          <div className={styles.row}>
            <div className={`${styles.field} ${styles.animate} ${styles.fadeLeft} ${styles.delay1}`} data-animate>
              <label>PHONE NUMBER</label>
              <input type="text" name="phone" value={formData.phone} onChange={handleChange} placeholder="(081) 800 - 8080" />
            </div>

            <div className={`${styles.field} ${styles.animate} ${styles.fadeRight} ${styles.delay1}`} data-animate>
              <label>SELECT SERVICE</label>
              <select name="service" value={formData.service} onChange={handleChange}>
                <option value="">Choose a service</option>
                {services.map((service, index) => (
                  <option key={index} value={service}>{service}</option>
                ))}
              </select>
            </div>
          </div>

          <div data-animate className={`${styles.field} ${styles.animate} ${styles.fadeUp} ${styles.delay2}`}>
            <label>YOUR MESSAGE</label>
            <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Your message...." />
          </div>

          <button
            data-animate
            type="submit"
            disabled={loading}
            className={`${styles.button} ${styles.animate} ${styles.scaleFade} ${styles.delay3}`}
          >
            {loading ? "Sending..." : "SEND MESSAGE"}
          </button>

          {success && (
            <p style={{ marginTop: "15px", color: "#4CAF50", fontWeight: "500" }}>
              ✅ Message sent successfully!
            </p>
          )}
        </form>
      </div>
    </section>
  );
};

export default ContactForm;